import { Textarea } from '../../../UIPackage/MainModule/components/Textarea';
import { renderDateForDisplayedSignatureInfo } from '../../../functions/renderDateForDisplayedSignatureInfo';
import styles from './ExternalSystemSignInfoBlock.module.scss';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';

const ExternalSystemSignInfoBlock = ({
  systemSignatureTitle,
  systemSignatureDateTime,
}: {
  systemSignatureDateTime: string;
  systemSignatureTitle: string;
}) => {
  return (
    <FieldBlock
      label={'Информация о подписании сведений технической подписью внешней информационной системы'}
      color="black"
    >
      <Textarea
        value={`Паспорт подписан по СМЭВ ${renderDateForDisplayedSignatureInfo(
          systemSignatureDateTime as string,
        )} в автоматическом режиме подписью системы "${systemSignatureTitle}"`}
        autoHeight
        disabled
        className={styles.TextArea}
      />
    </FieldBlock>
  );
};

export { ExternalSystemSignInfoBlock };
